/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Components.Controls {
  "use strict";

  export class MeevoUniqueEmailField implements angular.IDirective {
    require = "?ngModel";
    restrict = "E";
   
    //*******************************************************************//
    // Currently checks for Client Email Uniqueness.
    //*******************************************************************//
    //TODO: Add configurable scope key specify which endpoint
    // to check for uniqueues. (i.e. If we also need to determine if an
    // employee email is unique.)
    //*******************************************************************//

    scope = {
      entityId: "=",
      currentValue: "=ngModel",
      contentKey: "@",
      disabled: "=ngDisabled",
      required: "=ngRequired",
      placeholder: "@",
      tabIndex: "=?",
      onPostBlur: "&",
      change:"&ngChange",
    };

    templateUrl = "app/components/controls/uniqueEmailTemplate.html";

    link = (scope: any, element: JQuery, attrs: any, ngModelCtrl: any) => {
      let ds = this.dataService;
      let q = this.$q;

      element.on("click", (event: JQueryEventObject) => {
        if (!scope.isDisabled) {
          let target: any = event.target || event.srcElement;
          if (target.id === scope.id) {
            target.select();
          }
          event.preventDefault();
        }
      });

      scope.onBlur = () => {
          if (_.isFunction(scope.onPostBlur)) {
              window.setTimeout(() => { scope.onPostBlur(); }, 0);
          }
      }

      ngModelCtrl.$asyncValidators.unique = function (email) {

          let deferred = q.defer();
          let pattern = Meevo.Components.Common.Constants.REGEX_EMAIL_VALIDATOR;

          if (!scope.disabled && pattern.test(email)) {
              let request = {
                  client: {
                      id: scope.entityId,
                      emailAddress: email
                  },
                  validationType: Model.ClientValidationTypeEnum.UniqueEmailCheck
              }

              ds.validate("client", request).then((isUnique) => {
                  if (isUnique) {
                     deferred.resolve(true);
                  } else {
                      deferred.reject();
                  }
              });
          }
          else if (Model.Guard.isSomething(email) && !pattern.test(email)) {
              deferred.reject();
          }
          else {
              deferred.resolve();
          }

          return deferred.promise;
      }
    }

    constructor(private $q: angular.IQService, private dataService: Meevo.Components.BaseClasses.IDataService) {

    }

    static factory(): angular.IDirectiveFactory {
      let directive = ($q: angular.IQService, dataService: Meevo.Components.BaseClasses.IDataService) => {
        return new MeevoUniqueEmailField($q, dataService);
      };

      directive.$inject = ["$q", "meevo.components.common.DataService"];

      return directive;
    }
  }

  angular.module("meevo.components.controls")
    .directive("meevoUniqueEmailField", MeevoUniqueEmailField.factory());
}